module.exports = __webpack_public_path__ + "static/media/deepWalletSvg.acb7a211.svg";